import React from "react";
import { useFormikContext } from "formik";
import {
    emptySurveyQuestionResponse,
    RESPONSE_OPTION_MAX_LENGTH,
} from "utils/consts";
import { IconButton, Button, Tooltip } from "@material-tailwind/react";
import MaterialIcon from "components/material-icon";
import FormikTextarea from "./formik-textarea";

export default function QuestionAnswerInputs({
    questionIndex,
    pushCallback,
    removeCallback,
    swapCallback,
    questionAnswersToDelete,
    setQuestionAnswerDeleteArray,
    isReadOnly,
}) {
    const { values } = useFormikContext();

    const addResponse = () => {
        const newResponse = Object.assign({}, emptySurveyQuestionResponse);
        const pos =
            values.questions[questionIndex].preset_answers.length === 0
                ? 1
                : values.questions[questionIndex].preset_answers.length + 1;
        newResponse.position = pos;
        pushCallback(newResponse);
    };

    const moveResponseUp = (swap, index) => {
        const oldPos =
            values.questions[questionIndex].preset_answers[index].position;
        values.questions[questionIndex].preset_answers[index].position =
            values.questions[questionIndex].preset_answers[index - 1].position;
        values.questions[questionIndex].preset_answers[index - 1].position =
            oldPos;
        swap(index, index - 1);
    };

    const moveResponseDown = (swap, index) => {
        const oldPos =
            values.questions[questionIndex].preset_answers[index].position;
        values.questions[questionIndex].preset_answers[index].position =
            values.questions[questionIndex].preset_answers[index + 1].position;
        values.questions[questionIndex].preset_answers[index + 1].position =
            oldPos;
        swap(index, index + 1);
    };

    return (
        <>
            <div className="text-xs text-gray-500 mt-2 ml-4">
                Response options have a maximum of {RESPONSE_OPTION_MAX_LENGTH} characters
            </div>
            <div className="flex flex-col gap-4 p-4 sm:rounded-2xl rounded-xl mt-2">
                {values.questions[questionIndex].preset_answers
                    ?.sort((a, b) => {
                        return a.position - b.position;
                    })
                    .map((answer, index) => (
                        <div className="flex gap-2 items-center" key={index}>
                            <FormikTextarea
                                name={`questions.${questionIndex}.preset_answers.${index}.text`}
                                className="w-full font-body"
                                minRows={1}
                                autoComplete="off"
                                disabled={isReadOnly}
                                maxLength={RESPONSE_OPTION_MAX_LENGTH}
                                showCounter={true}
                            />
                            <IconButton
                                className="btn-icon--secondary"
                                type="button"
                                variant="text"
                                disabled={index === 0 || isReadOnly}
                                onClick={() =>
                                    moveResponseUp(swapCallback, index)
                                }
                            >
                                <MaterialIcon name="arrow_upward" size="xl" />
                            </IconButton>
                            <IconButton
                                className="btn-icon--secondary"
                                type="button"
                                variant="text"
                                disabled={
                                    index ===
                                        values.questions[questionIndex]
                                            .preset_answers?.length -
                                            1 || isReadOnly
                                }
                                onClick={() =>
                                    moveResponseDown(swapCallback, index)
                                }
                            >
                                <MaterialIcon name="arrow_downward" size="xl" />
                            </IconButton>
                            <IconButton
                                className="btn-icon--danger"
                                type="button"
                                variant="text"
                                onClick={() => removeCallback(index)}
                                disabled={isReadOnly}
                            >
                                <MaterialIcon name="delete" size="xl" />
                            </IconButton>
                        </div>
                    ))}
            </div>
            {!!(
                values.questions?.[questionIndex]?.question_type !== "freeform"
            ) && (
                <div className="flex justify-center">
                    <div>
                        <Tooltip
                            className="font-body"
                            animate={{
                                mount: { scale: 1, y: 0 },
                                unmount: { scale: 0, y: 25 },
                            }}
                            content={`Add a single or multiple response option. Response options have a maximum of ${RESPONSE_OPTION_MAX_LENGTH} characters.`}
                        >
                            <Button
                                variant="filled"
                                className="btn btn--primary"
                                type="button"
                                onClick={addResponse}
                                disabled={isReadOnly}
                            >
                                + Add A Response
                            </Button>
                        </Tooltip>
                    </div>
                </div>
            )}
        </>
    );
}
